import { DrawerLinksToReportsContainer } from "./container";

export const DrawerLinksToReports = () => {
  return <DrawerLinksToReportsContainer />;
};
